import styled from 'styled-components/macro';
import px2vw from '../../../utils/px2vw';

export const WhyQberaa = styled.div`
    /* padding-left:  ${props => props.theme.paddingLeft};
    padding-right: ${props => props.theme.paddingRight}; */
    padding-top:  ${px2vw(445)};
    background : linear-gradient(186.2deg, rgba(10, 37, 64, 0.05) 23%, rgba(10,37,64,1) 23%);
    color:#FFFFFF;
    position: relative; 
    @media only screen and (max-width: 425px) {
        padding-top:  ${px2vw(1000)};
        background : linear-gradient(186.2deg, rgba(10, 37, 64, 0.05) 15%, rgba(10,37,64,1) 15%);
        padding-left: 5%;
        padding-right: 5%;
    }
`;

export const WhyQberaaTitle = styled.div`
    font-family: ${props => props.theme.fontFamily};
    font-size:  ${props => { 
        return props.theme.mobCommonTitleFontSize?props.theme.mobCommonTitleFontSize:px2vw(20)
    }};  
    letter-spacing: ${props => props.theme.subtitleLetterSpacing};
    font-style: normal;
    font-weight: bold;
    line-height: ${px2vw(30)};
    padding-bottom: ${px2vw(14)};
    @media only screen and (max-width: 600px) {
        padding-bottom: ${px2vw(200)};
        line-height:${props => props.theme.pLineHeight};
    }
`;

export const WhyQberaaContent = styled.div`
    font-family: ${props => props.theme.fontFamily};
    font-size:  ${props => props.theme.pFontSize};
    line-height:  ${props => props.theme.pLineHeight};
    font-weight: 400;
    letter-spacing: ${props => props.theme.subtitleLetterSpacing};
    padding-bottom: ${px2vw(22)};
    @media only screen and (max-width: 425px) {
        padding-bottom: ${px2vw(52)};
    }
`;

export const WhyQberaaRedBox = styled.div`
    height: ${px2vw(12)};
    width: ${px2vw(81)};
    border-radius: 0px;
    background: #E32C5E;
    @media only screen and (max-width: 425px) {
        width: ${px2vw(300)};
        padding-top: ${px2vw(30)};
    }
`;

export const RedBoxContainer = styled.div` 
    display: flex;
    flex-direction: column;    
    position:absolute; 
    top: 24%;
    right: 0;
    transform: skewY(6.3deg);
    overflow: hidden;
    @media only screen and (max-width: 425px) {
        display: none;
}
`;

export const RightRedBox1 = styled.div`
    width:  ${px2vw(92)};
    height:  ${px2vw(18)};    
    position: relative;
    background: #E32C5E;     
`;

export const RightRedBox2 = styled.div`
    width:  ${px2vw(92)};
    height:  ${px2vw(9)};
    position: relative;
    background: #E32C5E; 
    opacity: 0.25; 
    left: ${px2vw(30)};
`;